import { render, staticRenderFns } from "./GoodDetails.vue?vue&type=template&id=5a778faa&scoped=true"
import script from "./GoodDetails.vue?vue&type=script&lang=js"
export * from "./GoodDetails.vue?vue&type=script&lang=js"
import style0 from "./GoodDetails.vue?vue&type=style&index=0&id=5a778faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a778faa",
  null
  
)

export default component.exports